import { useState, useCallback } from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { MobileNav } from "./components/MobileNav";

// Pages
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import AgendaPage from "./pages/AgendaPage";
import GalleryPage from "./pages/GalleryPage";
import PromosPage from "./pages/PromosPage";
import NotFoundPage from "./pages/NotFoundPage";

function App() {
  const [bookingTrigger, setBookingTrigger] = useState(0);

  const handleBookingClick = useCallback(() => {
    // Scroll to booking console on home page
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setBookingTrigger(prev => prev + 1);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Header onBookingClick={handleBookingClick} />
        
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<HomePage key={bookingTrigger} />} />
            <Route path="/servicios" element={<ServicesPage />} />
            <Route path="/agenda" element={<AgendaPage />} />
            <Route path="/galeria" element={<GalleryPage />} />
            <Route path="/promos" element={<PromosPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>

        <Footer />
        <MobileNav onBookingClick={handleBookingClick} />
        
        <Toaster 
          position="top-center"
          toastOptions={{
            style: {
              background: '#1A1A1A',
              color: '#F5F5F0',
              border: 'none',
              borderRadius: '12px',
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
